export const trendClassName = (score: number): string => {
  if (Math.sign(score) === 1) {
    return 'trend-up';
  } else {
    return 'trend-down';
  }
};
